<template>
<v-app>
  <div class="page-top-bg">
    <div class="slant"></div>
  </div>

  <v-content class="page-content pa-3 mx-auto">
    <div class="d-flex justify-center align-center text-cs-center loading-container" v-if="!is_app_initialized">
      <v-progress-circular
        :size="50"
        color="amber"
        indeterminate
      ></v-progress-circular>
    </div>
    <template v-else>

      <h3 v-if="is_auth_error">Token has expired or invalid.</h3>

      <h3 v-else-if="is_internal_error" class="text-xs-center">Unable to authenticate you.
        <br />
        Checkout cancelled.
      </h3>

      <template v-else>
        <v-container d-flex justify-end align-center px-0 pb-1 pt-0>
          <div class="flex-0 caption ssl">
            <v-icon size="14">mdi-lock</v-icon> SSL Secured
          </div>
        </v-container>
        <div class="payment-box d-flex justify-center column align-center">
          <div class="header flex-0">
            <div class="avatar-container">
              <div class="avatar" :style="{backgroundImage: `url(${S.user.avatar_url})`}"></div>
            </div>

            <div class="header-title">
              Premium Membership Upgrade
            </div>

            <div class="header-subtitle">
              $4.99 / month subscription
            </div>

            <v-btn icon class="close" @click="close()">
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
          </div>

          <div class="edge"></div>

          <div class="d-flex column payment-box-body pa-3">
            <div id="dropin-container"></div>

            <transition name="fade">
              <v-btn large block color="primary"
                @click="doPayment()"
                :disabled="S.is_loading || !bt_client_instance"
                :loading="S.is_loading"
                v-show="is_pay_button_visible"
                class="flex-0 px-5"
              >
                Buy Upgrade
              </v-btn>
            </transition>
          </div>
        </div>

        <div class="trailer">
          No committments.  Cancel anytime.
        </div>
      </template>

    </template>
  </v-content>

<v-dialog v-model="S.general_confirmation_dialog.is_visible" max-width="500" :persistent="S.general_confirmation_dialog.is_persistent">
  <v-card>
    <v-card-title class="px-3 py-2">
      <h3>{{S.general_confirmation_dialog.title}}</h3>
    </v-card-title>

    <v-card-text v-html="S.general_confirmation_dialog.body"></v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="darken-1" flat @click="S.general_confirmation_dialog.is_visible=false"
        v-if="S.general_confirmation_dialog.is_cancel_button_visible"
      >Cancel</v-btn>

      <v-btn color="primary" flat @click="()=>S.general_confirmation_dialog.confirmation_callback && S.general_confirmation_dialog.confirmation_callback()">{{ S.general_confirmation_dialog.confirm_button_text }}</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-app>
</template>

<script>
export default {
  components: {
    // HelloWorld: require("@/components/HelloWorld.vue").default,
  },

  beforeCreate() {
    window.Z = this

    this.$vuetify.theme = {
      primary: '#f3c669',//"#ffa042", //'#e73535',
      accent: '#f3c669',//'#ffa042', //'#2196F3',
      secondary: '#424242',
      info: '#80D8FF',
      warning: '#FFEE58',
      error: '#E53935',
      success: '#00E676',
    }

    this.S = window.S
  },

  data() {return {
    is_auth_error: false,
    is_internal_error: false,
    is_app_initialized: false,
    is_pay_button_visible: false,
    client_token: null,
    // key: null,
    // mid: null,
    // pid: null,
    // pkey: null,
    bt_client_instance: null,
    nonce: null,
    channel_id: null,
    return_url: null,
  }},

  mounted() {
    this.initializeData()
    //this.initializePusher()
  },

  beforeDestroy() {
  },

  methods: {
    async initializeData() {
      this.is_app_initialized = false

      try {
        const token = this.$route.query.token || process.env.VUE_APP_USER_IDENTITY_TOKEN
        let {data} = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/rapi/v9/bt-client-token?token=${token}`)
        l('data:')
        l(data)

        S.user = data.user
        this.client_token = data.client_token
        // this.key = data.key
        // this.mid = data.mid
        // this.pid = data.pid
        // this.pkey = data.pkey
      } catch (err) {
        l('unable to get brief user checkout data for some unknown reason.')
        this.is_internal_error = true
        this.is_app_initialized = true

        // setTimeout(()=>{
        //   window.history.go(-2)
        // }, 5000)
        return
      }

      this.initializeBT()

      this.is_app_initialized = true
    },

    initializeBT() {
      braintree.dropin.create({
        authorization: this.client_token,
        container: '#dropin-container',
        paypal: {
          flow: 'vault',
        }
      }, this.btInitialized)
    },

    btInitialized(err, client_instance) {
      if (err) {
        return l(err)
      }

      this.bt_client_instance = client_instance

      setTimeout(()=>{
        this.is_pay_button_visible = true
      }, 300)
    },

    initializePusher() {
      this.channel_id = S.guid()

      // this.pusher = new Pusher(pusher_public_key, {
      //   cluster: 'us2',
      //   encrypted: true
      // })

      // this.channel = pusher.subscribe(this.channel_id)
      // channel.bind('my-event', function(data) {
      //   alert(JSON.stringify(data));
      // })
    },

    doPayment() {
      if (!this.bt_client_instance)
        return

      if (S.is_loading)
        return

      S.is_loading = true

      this.bt_client_instance.requestPaymentMethod((err, payload)=>{
        if (err) {
          l('payment error:')
          l(err)
          S.alert("Invalid payment information!  Please double check your inputs.")
          S.is_loading = false
          return
        }

        if (payload) {
          l('payload:')
          l(payload)
          let nonce = payload.nonce
          this.processPayment(nonce)
        }
      })
    },

    async processPayment(nonce) {
      try {
        let {data} = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/rapi/v9/bt-purchase`, {
          token: this.$route.query.token || process.env.VUE_APP_USER_IDENTITY_TOKEN,
          nonce: nonce,
          channel_id: this.channel_id,
        })

        if (data.status == 'fail') {
          S.alert(data.msg)
          S.is_loading = false
          return
        }

        this.is_pay_button_visible = false

        this.return_url = data.url

        S.confirm({
          is_cancel_button_visible: false,
          confirm_button_text: "OK",
          confirmation_callback: ()=>{
            window.location.href = this.return_url
          },
          title: "Welcome!",
          body: "Your order has processed successfully!<br /><br />Thank you for being our newest Premium Member.  You may now access FullHD 1080p videos, faster streaming video servers, no more ads, and other benefits!",
        })
      } catch (err) {
        l(err)
        S.confirm({
          is_cancel_button_visible: false,
          confirm_button_text: "OK",
          confirmation_callback: ()=>{S.general_confirmation_dialog.is_visible=false},
          title: "Unable to Process Payment",
          body: "Our payment processor was unable to process your payment.<br /><br />It could be for many reasons.<br /><br />Try a different card or payment method.",
        })
      }

      S.is_loading = false
    },

    close() {
      window.history.go(-2)
    },

  },
}
</script>

<style lang="scss" src="./stylesheets/_all.scss">
</style>